import { Components, Theme } from '@mui/material'
import PaletteTheme from '../palette'

const inputLabel: Components<Theme>['MuiInputLabel'] = {
  defaultProps: {
    shrink: true
  }
}

const textField: Components<Theme>['MuiTextField'] = {
  defaultProps: {
    variant: 'outlined',
    size: 'small',
    slotProps: { inputLabel: { shrink: true } }
  }
}

const select: Components<Theme>['MuiSelect'] = {
  defaultProps: {
    variant: 'outlined',
    size: 'small'
  }
}

const outlinedInput: Components<Theme>['MuiOutlinedInput'] = {
  styleOverrides: {
    root: {
      '&.Mui-disabled': {
        backgroundColor: PaletteTheme.grey?.[25]
      }
    }
  }
}

export { inputLabel, textField, select, outlinedInput }
